import cn from "classnames"
import React, { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isTablet } from "@/common/util"
import AdminAnimated from "@/images/signomatic/pikachu.gif"
import AdminStatic from "@/images/signomatic/pikachu.png"
import whooo from "@/images/signomatic/whoo.gif"

export interface ToolboxButtonProps {
  icon: any
  buttonRef: React.RefObject<HTMLDivElement> | null
  active?: boolean
  disabled?: boolean
  whoo?: boolean
  toolbox?: string
  labelKey?: string
  onClick?: () => void
  signColor?: string
}

const AdminIcon: React.FC<{ over: boolean }> = ({ over }) => {
  useEffect(() => {
    const image = new Image()
    image.src = AdminAnimated
  }, [])

  const src = over ? AdminAnimated : AdminStatic

  return <img src={src} alt="" className="p-2" />
}

const ColorIcon: React.FC<{ signColor?: string }> = ({ signColor }) => {
  return (
    <svg viewBox="0 0 25 31" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.112 24.71a3.61 3.61 0 0 1-2.456-.933l-7.527-6.91c-.737-.678-1.128-1.543-1.128-2.5 0-.943.401-1.833 1.128-2.499l8.467-7.773L7.53 2.17A1.2 1.2 0 0 1 7.544.367 1.476 1.476 0 0 1 9.507.38l12.254 11.402c1.333 1.24 1.326 3.252-.016 4.487l-8.18 7.51a3.607 3.607 0 0 1-2.455.933l.002-.001zm.436-18.801l-8.455 7.763a.924.924 0 0 0-.314.695.88.88 0 0 0 .314.694l7.526 6.91a.717.717 0 0 0 .493.187.726.726 0 0 0 .49-.186l8.18-7.509a.6.6 0 0 0 .002-.893L11.55 5.907l-.001.002zm7.896 16.873c0-1.968 2.383-3.501 2.777-5.44.399 1.94 2.778 3.485 2.778 5.44 0 1.503-1.244 2.72-2.778 2.72-1.535 0-2.777-1.219-2.777-2.72zm3.333-8.756L11.574 24.312 2.11 15.624c-.48-.442-.722-1.598-.722-1.598h21.388z"
        className="fill"
      />
      <path
        d="M23.61 30.603H1.39c-.768 0-1.39-.57-1.39-1.276 0-.705.622-1.275 1.39-1.275h22.22c.769 0 1.39.57 1.39 1.275s-.621 1.276-1.39 1.276z"
        style={{ fill: signColor }}
      />
    </svg>
  )
}

const ToolboxIcon: React.FC<{ toolbox?: string; icon: any; whoo?: boolean; over: boolean; signColor?: string }> = ({
  toolbox,
  whoo,
  icon,
  over,
  signColor,
}) => {
  if (toolbox === "admin") {
    return <AdminIcon over={over} />
  }

  if (whoo) {
    return <img src={whooo} alt="" />
  }

  if (toolbox === "color") {
    return <ColorIcon signColor={signColor} />
  }

  return React.createElement(icon)
}

const ToolboxButton: React.FC<ToolboxButtonProps> = ({
  icon,
  labelKey,
  toolbox,
  active,
  disabled,
  whoo,
  buttonRef,
  onClick,
  signColor,
}) => {
  const { t } = useTranslation()
  const label = t(labelKey || `toolbox.${toolbox}`)
  const [over, setOver] = useState(false)

  const click = (e: React.MouseEvent) => {
    e.stopPropagation()

    if (disabled) {
      return
    }

    if (onClick) {
      onClick()
    }
  }

  const enter = useCallback(() => setOver(true), [])
  const leave = useCallback(() => setOver(false), [])

  return (
    <div
      ref={buttonRef}
      onClick={click}
      className={cn("menu_button border-0", toolbox, { active, disabled })}
      onMouseEnter={enter}
      onMouseLeave={leave}
    >
      <div className={cn("icon")}>
        <ToolboxIcon whoo={whoo} toolbox={toolbox} icon={icon} over={over} signColor={signColor} />
      </div>
      <div className={cn("text", { "paragraph-2xs center mb-0": isTablet() })}>{label}</div>
    </div>
  )
}

export default ToolboxButton
